<karaoke-nav-bar></karaoke-nav-bar>
<router-outlet></router-outlet>
